/**
 * digitgrouping creates the window.groupDigits function.
 *
 * window.groupDigits seperates groups of digis with a delimiter: 100.000 10.000.000 1.000
 * - digits: String      (Digits to group, ie '12345678,95' or '1234567')
 */

function digitgrouping() {
	function groupDigits(digits) {
		if (digits == undefined) {
			return;
		}
		let integer;
		let fractional;
		let retval;

		/* Turn to string for counting and splitting */
		digits = digits.toString();

		/* If it has a decimal mark, split up */
		if (digits.indexOf(',') >= 0) {
			const arr = digits.split(',');
			integer = arr[0];
			fractional = arr[1];
		} else {
			integer = digits;
		}

		/* If the integer part is at least four characters long, then continue. Otherwise it's pointless, since 100 10 and 1 do not require a delimiter. */
		if (integer.length >= 4) {
			/* Seperate the integer part, starting backwards, every three characters. */
			let dottedInteger = integer;
			for (let i = integer.length - 3; i > 0; i -= 3) {
				dottedInteger = `${dottedInteger.substring(0, i)}.${dottedInteger.substring(i, dottedInteger.length)}`;
			}
			integer = dottedInteger;
		}

		retval = fractional == undefined ? integer : `${integer},${fractional}`;
		return retval;
	}

	window.groupDigits = groupDigits;

	Vue.filter('groupDigits', window.groupDigits);
}
digitgrouping();
